import { Box, SvgIconProps, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "./styles";

type CircleProgressProps = {
  value: number;
  color: string;
  icon?: React.ReactNode;
  text: string;
};

export default function CircleProgress({
  value,
  color,
  icon,
  text,
}: CircleProgressProps) {
  const classes = useStyles;

  return (
    <Box sx={{ textAlign: "center", paddingTop: 4 }}>
      <Box
        sx={{
          ...classes.circleBox,
          borderColor: color,
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          margin: "auto",
        }}
      >
        <Box sx={classes.icon}>{icon}</Box>
        <Typography
          component={"h4"}
          variant={"h4"}
          sx={{ fontSize: { md: "3rem", xs: "1.8rem" } }}
        >
          {value}
        </Typography>
      </Box>
      <Typography
        component={"h4"}
        variant={"h4"}
        sx={{
          marginTop: { md: 3, xs: 1 },
          fontSize: { md: "2rem", xs: "1.6rem" },
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
